import styled from 'styled-components'

const Wrapper = styled.div`
  label {
    margin-bottom: 0;
    color: #637381;
  }

  .label-with-value {
    margin-top: 10px;
  }
`

export default Wrapper
